/**
 * @author       Matthieu Devlin (matt@zumper.com)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  addRecombeeToLocalStorage.ts
 */

import type { ExpirableStorage } from '@zcode/storage'
import { ONE_HOUR } from '@zcode/utils'
import type { LocalStorage } from '../types/LocalStorage'

export const addRecombeeToLocalStorage = (
  localStorage: ExpirableStorage | LocalStorage,
  recommId: string
) => {
  // @ts-expect-error
  if (!localStorage.server) {
    if (recommId) {
      localStorage.setItem('attributedRecommId', recommId, ONE_HOUR)
    }
  }
}
